import React from 'react';
import { heroImages } from '../mock';
import { PillPrimary } from '../components/PillButton';
import { Check } from 'lucide-react';

const Egas = () => (
  <div className="bg-[#2b2b2b]">
    <section className="pt-32 pb-16 md:pt-40 md:pb-24 bg-[#141414] relative overflow-hidden">
      <div className="absolute inset-0 bg-cover bg-center opacity-25" style={{ backgroundImage: `url(${heroImages.gas1})` }} />
      <div className="relative max-w-[1200px] mx-auto px-6 lg:px-10">
        <div className="inline-block px-5 py-2.5 rounded-full border border-[#e9dfc0]/40 text-[#e9dfc0] text-[13px] mb-6">Divisione industriale</div>
        <h1 className="font-serif text-white text-5xl md:text-7xl leading-[1.05] mb-6">E-gas / Project Solution</h1>
        <p className="text-[#e9dfc0]/85 text-[17px] max-w-3xl">Distribuzione e consulenza su gas tecnici industriali per settori manifatturieri, ricerca e produzione.</p>
      </div>
    </section>

    <section className="py-24">
      <div className="max-w-[1200px] mx-auto px-6 lg:px-10 grid md:grid-cols-2 gap-12 items-center">
        <div>
          <h2 className="font-serif text-white text-3xl md:text-4xl mb-6">Soluzioni tecniche per l'industria</h2>
          <ul className="space-y-3 text-[#e9dfc0]/90">
            {['Fornitura gas tecnici puri e miscele','Consulenza normativa e sicurezza','Gestione bombole e logistica dedicata','Assistenza tecnica sul campo','Progetti chiavi in mano'].map((x) => (
              <li key={x} className="flex items-start gap-3"><Check className="w-5 h-5 text-[#e9dfc0] mt-0.5" /><span>{x}</span></li>
            ))}
          </ul>
        </div>
        <div className="aspect-square bg-cover bg-center rounded-2xl" style={{ backgroundImage: `url(${heroImages.gas2})` }} />
      </div>
    </section>

    <section className="bg-[#e9dfc0] py-20">
      <div className="max-w-3xl mx-auto px-6 text-center">
        <h2 className="font-serif text-[#2b2b2b] text-3xl md:text-4xl mb-6">Hai un progetto industriale?</h2>
        <PillPrimary to="/contatti" className="!bg-[#2b2b2b] !text-[#e9dfc0]">Parliamone</PillPrimary>
      </div>
    </section>
  </div>
);

export default Egas;
